query PurchaseOrderItem($id: UUID!) {
  purchaseOrderItem(id: $id) {
    _rowTimestamp
    purchaseOrderItemType {
      calculationType
      layoutType
      abbreviation
      description
      id
    }
    taxTypeId
    subjectToAmount
    purchaseOrderItemTypeId
    __typename
    id
    expenditureType {
      id
    }
    unitOfMeasureItemId
    unitOfMeasureItem {
      abbreviation
      unitOfMeasureItem
      id
      _unitOfMeasureGroupId
    }
    _isUpdatable
    _isDeletable
    scheduledDeliveryDate
    additionalDepartmentId
    additionalBusinessUnitId
    deliveryTelephoneNumber
    deliveryStateRegionId
    deliveryPostalCode
    deliveryNotes
    deliveryMainContact
    deliveryMobileNumber
    deliveryEmailAddress
    deliveryCountryId
    deliveryCityName
    deliveryAttention
    deliveryAlternateContact
    deliveryAddressLine2
    deliveryAddressId
    deliveryAddressLine1
    _isActive
    _isDeprecated
    _isModified
    _isPartialReturn
    itemYears
    itemYearRate
    itemYearAmount
    itemWeeks
    itemWeekRate
    itemWeekAmount
    itemUnitPrice
    itemToDate
    itemRentalDates
    itemQuantity
    itemNumber
    itemMonths
    itemMonthRate
    itemMonthAmount
    itemHours
    itemHourRate
    itemHourAmount
    itemFromDate
    itemExtendedAmount
    itemDays
    itemDayRate
    itemDayAmount
    isTaxable
    isDiscounted
    isPackingSlipAttachmentRequired
    isDeliveryTracked
    isDeliveryAddressProtected
    expenditureTypeId
    displayPoItemUnitPrice
    displayPoItemAccount
    displayPoItemDescription
    displayPoItemRentalTerm
    displayPoItemTotal
    displayPoItemQuantity
    displayPoItemUnitPrice
    displayPoItemType
    description
    _extendedItemTotal
    purchaseOrderItemDistributions {
      nodes {
        id
        _createdDate
        _isDeletable
        _isUpdatable
        _rowTimestamp
        accountReference
        _accountName
        referenceCode6
        referenceCode7
        allocationPercent
        distributionAmount
        productionIncentiveId
        projectReference
        setReference
        tax1099T4TypeId
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode5
      }
    }
  }
}
